var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArtIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 21202",
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 82818"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 23406",
    d: "M4.001 13.074a8 8 0 015.916-7.383 8.028 8.028 0 017.056 1.239c.121.084.123.15.065.275q-1.321 2.845-2.627 5.7a3.657 3.657 0 00-.2.732c-.018.083-.034.131-.12.163a2.141 2.141 0 00-1.19 1.058.311.311 0 01-.147.134 5.851 5.851 0 00-2.675 2.16 3.027 3.027 0 01-2.5 1.4 3.086 3.086 0 01-3.018-2.022 8.883 8.883 0 01-.56-3.456zm1.908.454a1.4 1.4 0 101.4-1.392 1.4 1.4 0 00-1.4 1.392zm1.744-4.007a1.391 1.391 0 101.39-1.385 1.391 1.391 0 00-1.39 1.385zm6.961-1.213a1.4 1.4 0 10-.413.989 1.391 1.391 0 00.413-.989z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 23407",
    d: "M15.8 14.696a1.435 1.435 0 01.508 1.241 1.911 1.911 0 01-.2.647 3.61 3.61 0 01-2.648 1.966.988.988 0 01-.131.013.131.131 0 01-.04-.007 3.909 3.909 0 00.136-.746 10.5 10.5 0 00-.107-1.181 2.624 2.624 0 01.154-1.344 1.468 1.468 0 011.583-.913h.095a1.017 1.017 0 01-.214-.926 1.31 1.31 0 01.079-.213l3.6-7.8a.65.65 0 111.207.48c-.309.847-.623 1.692-.934 2.537-.658 1.787-1.324 3.575-1.969 5.367a1.113 1.113 0 01-1.119.879z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 23408",
    d: "M19.259 9.484c1.285 1.928.8 3.82-.694 4.818a2.953 2.953 0 01-1.329.472 18.626 18.626 0 00.929-2.342c.356-.928.688-1.864 1.031-2.8l.063-.148z"
  }))));
}
export default SvgArtIcon;